/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Per-organization switches and budgets for chat session analysis judges.
 */
export type ChatAnalysisSettings = {
  /**
   * Maximum business-memory extraction evaluations reserved across the organization each UTC day. 0 disables extraction.
   */
  businessMemoryDailyCap: number;
  /**
   * Whether completed sessions are mined for business memories.
   */
  businessMemoryEnabled: boolean;
  /**
   * Whether these values are platform defaults rather than stored organization settings.
   */
  isDefault: boolean;
  /**
   * Organization these settings apply to.
   */
  organizationId: string;
  /**
   * Maximum work-units evaluations reserved across the organization each UTC day. 0 disables scoring as surely as the switch.
   */
  workUnitsDailyCap: number;
  /**
   * Whether work-units chat analysis is enabled.
   */
  workUnitsEnabled: boolean;
};

/** @internal */
export const ChatAnalysisSettings$inboundSchema: z.ZodMiniType<
  ChatAnalysisSettings,
  unknown
> = z.pipe(
  z.object({
    business_memory_daily_cap: z.int(),
    business_memory_enabled: z.boolean(),
    is_default: z.boolean(),
    organization_id: z.string(),
    work_units_daily_cap: z.int(),
    work_units_enabled: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "business_memory_daily_cap": "businessMemoryDailyCap",
      "business_memory_enabled": "businessMemoryEnabled",
      "is_default": "isDefault",
      "organization_id": "organizationId",
      "work_units_daily_cap": "workUnitsDailyCap",
      "work_units_enabled": "workUnitsEnabled",
    });
  }),
);

export function chatAnalysisSettingsFromJSON(
  jsonString: string,
): SafeParseResult<ChatAnalysisSettings, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ChatAnalysisSettings$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ChatAnalysisSettings' from JSON`,
  );
}
